import {FormControl,FormLabel,Input,  Button, ButtonGroup , Flex, Tooltip } from '@chakra-ui/react'
import { useForm } from "react-hook-form";
import {Lokacija,Toviliste,Odjeljak  } from '../../util/apiLokacija';



const LokacijaView = ({lokacijatipid,id,sifra,naziv,parentid,readonly,onSave,onCancel, size='xs'}) => {
    
    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = (data, event) => {
        event.preventDefault();
        //const _dz=new Drzava(drzava.id,data.sifra,data.naziv);
        let res;
        if (lokacijatipid===1) {//lokacija
            res=new Lokacija(id,data.sifra,data.naziv);
        } else if (lokacijatipid===2) {//tovilište
            res=new Toviliste(id,data.sifra,data.naziv,parentid);
        } else if (lokacijatipid===3) {//odjeljak
            res=new Odjeljak(id,data.sifra,data.naziv,parentid);
        }
            
        
        onSave(res)
    }
    const onCancelClick=(event)=>{
        onCancel();
    }

    

    const PreventEnter=(e)=>{
        e.keyCode===13 && e.preventDefault();
    }

    return (
        <Flex direction={'column'} scrollBehavior={'auto'} gap={'0.3rem'}>
        <form onSubmit={handleSubmit(onSubmit)} onKeyDown={PreventEnter}>
        <Input focusBorderColor='grunt2.400' size={size} type={'hidden'} {...register("id")}></Input>
        
            
            
            
            <FormControl mb={'0.5rem'} isInvalid={errors.sifra} isReadOnly={readonly}>
                <FormLabel fontSize={size}>Šifra</FormLabel>
                <Tooltip hasArrow label='Polje je obavezno' bg='red' color='white'  isDisabled={!errors.sifra}>
                    <Input focusBorderColor='grunt2.400' size={size} variant={'filled'} maxLength={10} {...register("sifra",{required:true})} autoCapitalize={'characters'} defaultValue={sifra}></Input>
                </Tooltip>
            </FormControl>
            <FormControl mb={'0.5rem'} isInvalid={errors.naziv} isReadOnly={readonly}>
                    <FormLabel fontSize={size}>Naziv</FormLabel>
                    <Tooltip hasArrow label='Polje je obavezno' bg='red' color='white' isDisabled={!errors.naziv}>
                        <Input focusBorderColor='grunt2.400' size={size} variant={'filled'}  maxLength={20} {...register("naziv",{required:true})} defaultValue={naziv}></Input>
                    </Tooltip>
            </FormControl>
            
            
           
            
            
            <ButtonGroup gap={'2rem'}>
                {readonly?<></>:<Button type={'submit'} colorScheme={'grunt2'} size={size}>Spremi</Button>}
                <Button colorScheme={'grunt2'} variant={'outline'} size={size} onClick={onCancelClick}>Odustani</Button>
            </ButtonGroup>
        </form>
        </Flex>
    );
}

export default LokacijaView;
